import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      light: {
        primary: '#33cc33',
        secondary: '#b0bec5',
        accent: '#FB8C00',
        error: '#b71c1c',
        bg2: "#eee",
        bg3: "#ddd"
      },
      dark: {
        primary: '#33cc33',
        secondary: '#b0bec5',
        accent: '#FB8C00',
        error: '#b71c1c',
        bg2: '#222',
        bg3: '#333'
      }
    },
  },
});
